var url = "5a6845a9716c7f5c89845c2eb2fea79f.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;